module.exports = __webpack_public_path__ + "img/nr.ced58ff2.svg";